import { gql, useMutation } from "@apollo/client";

import {
  AddServiceInput,
  BatchAddServicesMutation,
  BatchAddServicesMutationVariables,
} from "../../../API";
import { BATCH_ADD_SERVICES } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";

export const useCreateBatchServices = () => {
  const [saveBatchCreateServices, { data, loading }] = useMutation<
    BatchAddServicesMutation,
    BatchAddServicesMutationVariables
  >(BATCH_ADD_SERVICES);

  const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

  const batchCreateServices = async (
    input: Omit<AddServiceInput, "timeZone">[]
  ) => {
    return await saveBatchCreateServices({
      variables: {
        input: input.map(i => ({
          ...i,
          timeZone,
        })),
      },
      awaitRefetchQueries: true,
      onError: handleApolloError,
      update: async (cache, response) => {
        cache.modify({
          fields: {
            getServices(existing) {
              const newServicesRefs =
                response?.data?.batchAddServices?.map(s => {
                  return cache.writeFragment({
                    data: s,
                    fragment: gql`
                      fragment NewService on Service {
                        customerId
                        deviceId
                        healthData
                        id
                        isRunning
                        locationId
                        nodeId
                        serviceType
                        configuration
                      }
                    `,
                  });
                }) ?? [];

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [...existing.items, ...newServicesRefs],
              };
            },
          },
        });
      },
      refetchQueries: ["GetServices", "GetZonesByDevice"],
    });
  };

  return {
    batchCreateServices,
    data,
    loading,
  };
};
